import { render } from "./mask.vue?vue&type=template&id=b840eb42&scoped=true"
const script = {}

import "./mask.vue?vue&type=style&index=0&id=b840eb42&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b840eb42"]])

export default __exports__